import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetUserIdentityAccessTokenRequestObjectType,
  GetUserIdentityAccessTokenResponseType
} from '../../../services/NwApplicationServices/APIService/types';

import { useNwApplicationService } from '../useNwApplicationService';

interface UseGetUserIdentityAccessTokenInterface {
  getUserIdentityAccessTokenApi: UseMutateAsyncFunction<
    GetUserIdentityAccessTokenResponseType,
    Error,
    GetUserIdentityAccessTokenRequestObjectType
  >;
  error: string | null;
  status: MutationStatus;
}

const useGetUserIdentityAccessTokenApi =
  (): UseGetUserIdentityAccessTokenInterface => {
    const { nwApplicationService } = useNwApplicationService();

    const getUserIdentityAccessToken = (
      requestObject: GetUserIdentityAccessTokenRequestObjectType
    ) => {
      return nwApplicationService.getUserIdentityAccessToken(requestObject);
    };

    const { mutateAsync, error, status } = useMutation(
      getUserIdentityAccessToken,
      {
        mutationKey: ['getUserIdentityAccessTokenApi']
      }
    );

    return {
      getUserIdentityAccessTokenApi: mutateAsync,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useGetUserIdentityAccessTokenApi };
